import { forwardRef } from 'react';
import cn from 'clsx';
import { AnimatedStaticCoinRive } from "../../AnimatedStaticCoinRive";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DefaultSide = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$animated = props.animated,
    animated = _props$animated === void 0 ? true : _props$animated,
    className = props.className,
    style = props.style,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    isPlaying = props.isPlaying,
    coins = props.coins;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: cn('tw-flex tw-items-center tw-flex-nowrap',
    // Background color
    'tw-bg-warning-100',
    // Size
    'tw-w-auto tw-h-3.2 tw-p-0.4',
    // Rounded
    'tw-rounded-0.8',
    // Hover
    animated && 'tw-transition-all tw-duration-300 hover:tw-shadow-01 dark:hover:tw-shadow-none hover:tw-scale-110 tw-delay-75', className),
    style: style,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-testid": props.dataTestId,
    children: [/*#__PURE__*/_jsx(AnimatedStaticCoinRive, {
      startAnimation: isPlaying
    }), /*#__PURE__*/_jsx("span", {
      className: "tw-ml-0.4 tw-font-subtitle5 tw-text-warning-500 tw-line-clamp-1",
      children: coins
    })]
  });
});
DefaultSide.displayName = 'DefaultSide';
export default DefaultSide;